import React from 'react'
import { Helmet } from "react-helmet-async";

export const HelmetComponent = ({title}) => {
  return (
    <Helmet>
        <title>{title}</title>
        {/* <meta name="description" content="This is a custom description for SEO." /> */}
        <meta name="keywords" content="Edshopify, coursebuilder" />
    </Helmet>
  )
}
